import { change } from 'redux-form';

import { loading, success, error } from 'State/actions';
import { CREATE_TRANSACTION_FORM_NAME } from 'Common/FormEnum';
import { TransactionSummaryEnum } from 'Common/FieldEnum';

import * as types from './types';

export const getPhysicalForTranSummary = endDT => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING, true));
    try {
      const response = await MPWWebApi.getGeneric(
        `TranSummary/GetPhysicalForTranSummary/${endDT}`
      );
      dispatch(
        success(
          types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA,
          response.data.Data
        )
      );
    } catch (err) {
      dispatch(
        error(types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING_ERROR, err)
      );
    } finally {
      dispatch(
        loading(types.GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_LOADING, false)
      );
    }
  };
};
export const getTranPreview = filterOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'TranSummary/GetPreview',
        filterOptions
      );
    } catch (err) {
      dispatch(
        error(types.GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING_ERROR, err)
      );
    } finally {
      dispatch(loading(types.GET_EXISTING_TRAN_SUMMARY_PREVIEW_LOADING, false));
    }
  };
};
export const clearCreateTransactionSummaryError = () => {
  return {
    type: types.CLEAR_CREATE_TRANSACTION_SUMMARY_ERROR,
  };
};
export const closePeriod = filterOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.CLOSE_PERIOD_LOADING, true));
    try {
      await MPWWebApi.postGenericInsertUpdate(
        'TranSummary/WriteClosePeriod',
        filterOptions
      );
    } catch (err) {
      dispatch(error(types.CLOSE_PERIOD_LOADING_ERROR, err));
    } finally {
      dispatch(loading(types.CLOSE_PERIOD_LOADING, false));
    }
  };
};
export const getOpenTransactionWarning = filtersOptions => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.GET_OPEN_TRANSACTION_WARNING_MSG_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TranSummary/GetOpenTransactionWarning',
        filtersOptions
      );
      dispatch(
        success(types.GET_OPEN_TRANSACTION_WARNING_MSG_DATA, response.data.Data)
      );
    } catch (err) {
      dispatch(
        error(types.GET_OPEN_TRANSACTION_WARNING_MSG_LOADING_ERROR, err)
      );
    } finally {
      dispatch(loading(types.GET_OPEN_TRANSACTION_WARNING_MSG_LOADING, false));
    }
  };
};
export const showWarningMsg = showHide => {
  return {
    type: types.SHOW_WARNING_MSG,
    payload: showHide,
  };
};
export const clearGetPhysicalGridData = () => {
  return {
    type: types.CLEAR_GET_PHYSICAL_FOR_TRAN_SUMMARY_LIST_DATA,
  };
};
export const setBeginDT = beginDate => {
  return change(
    CREATE_TRANSACTION_FORM_NAME,
    TransactionSummaryEnum.BeginDT,
    beginDate
  );
};
export const setEndDT = endDate => {
  return change(
    CREATE_TRANSACTION_FORM_NAME,
    TransactionSummaryEnum.EndDT,
    endDate
  );
};



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transactionSummary/state/CreateTransaction/actions.js